import { ReactElement } from 'react';

export default function InputError({ children }: { children?: ReactElement }) {
    return <p className="mt-[-10px] typo-b2 regular text-danger ml-2">{children}</p>;
}
